import { hashColor } from '../../entities/util-functions';
import { CheckIcon, PenIcon, TrashIcon } from '../../components/shared';
import { ITaskResource } from '../../entities/task.entities';
import boat_png from '../../images/boat.png';
import { useSelector } from 'react-redux';
import { selectLang } from '../../store/ui/ui.selector';
import { translate } from '../../lib/lang.helper';
import { selectFarmsData } from '../../store/farms/farms.selector';
import { FarmDiv, LineDiv } from './CalendarCell';

interface Props {
  task: ITaskResource;
  onShowTask: (t: ITaskResource) => void;
  onCompleteTask: (t: ITaskResource) => void;
  onEditTask: (t: ITaskResource) => void;
  onDeleteTask: (t: ITaskResource) => void;
}

const TaskCell = ({
  task,
  onShowTask,
  onCompleteTask,
  onEditTask,
  onDeleteTask,
}: Props) => {
  const lang = useSelector(selectLang);
  const farmsData = useSelector(selectFarmsData);

  const farm = farmsData?.find(f => f.id === task.farm_id);
  const line = farm?.lines.find(l => l.id === task.line_id);

  const handleCompleteClick = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    onCompleteTask(task);
  };
  const handleEditClick = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    onEditTask(task);
  };
  const handleShowClick = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    onShowTask(task);
  };
  const handleDeleteClick = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    onDeleteTask(task);
  };

  return (
    <div
      className={`--entity --task ${
        task.is_declined ? '--declined' : task.is_completed ? '--completed' : ''
      }`}
      onClick={handleShowClick.bind(this)}
    >
      <div className='--header'>
        <span>{translate(lang, 'task')}</span>
      </div>
      <div className='--title --task-title'>{task.title}</div>
      <div className='d-flex flex-wrap gap-7 mt-7'>
        {farm && <FarmDiv farm={farm} />}
        {line && <LineDiv line={line} />}
      </div>
      <div className='d-flex justify-between mt-7'>
        {task.boat ? (
          <div
            className='--boat-img'
            style={{
              backgroundColor: hashColor(task.boat.reg_number),
            }}
          >
            <img src={boat_png} alt='boat' />
          </div>
        ) : (
          <div></div>
        )}
        <div className='d-flex'>
          {!task.is_completed && (
            <button
              className='complete-btn'
              onClick={handleCompleteClick.bind(this)}
            >
              <CheckIcon />
            </button>
          )}
          {!task.is_declined && (
            <button className='edit-btn' onClick={handleEditClick.bind(this)}>
              <PenIcon />
            </button>
          )}
          <button className='delete-btn' onClick={handleDeleteClick.bind(this)}>
            <TrashIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TaskCell;
